// extracted by mini-css-extract-plugin
export default {"products":"rA-z","card":"sA-z","oosMessaging":"tA-z"};